import React from "react"
import { Route, Switch, useRouteMatch } from "react-router-dom"
import { DioboxEvent } from "sharedTypes"
import LanguageTemplatesList from "./LanguageTemplatesList"
import EditLanguageTemplatePage from "./EditLanguageTemplatePage"

type Props = {
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const LanguageTemplates = ({ event, updateEvent }: Props) => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${path}/:templateId/edit`}>
        <EditLanguageTemplatePage eventId={event.id} backPath={url} />
      </Route>
      <Route path={path} exact>
        <LanguageTemplatesList event={event} updateEvent={updateEvent} />
      </Route>
    </Switch>
  )
}

export default LanguageTemplates
